<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="shipmentInspectKlms/getNoComplete"
        @update:filter="reset"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
<!--        <el-button type="primary" @click="$refs.editPage.open(0)">新建</el-button>-->
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="出厂编号">
            <el-input v-model.trim="filter.factoryNo" clearable/>
          </vm-search>
          <vm-search label="发运状态">
            <el-select v-model.trim="filter.completeEndState" clearable placeholder="请选择发运状态">
              <el-option label="未发运" :value="0"/>
              <el-option label="已发运" :value="1"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="factoryNo" width="120" align="center" label="出厂编号">
        <template slot-scope="scope">
          <div style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.factoryNo}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="sapOrderNo" width="120" align="center" label="sap订单号"/>
      <el-table-column prop="clientContractNo" width="120" align="center" label="客户合同号"/>
      <el-table-column prop="orderType" width="120" align="center" label="订单类型"/>
      <el-table-column prop="note" align="center" label="备注"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editPage.open(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status===0" type="primary" @click="submit(scope.row.pkid)">提交</el-button>
          <el-button v-if="scope.row.status===0 || delAuth" type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <!--    <improved-survey-edit ref="editPage" @save-success="getList(1)"/>-->
    <inspection-k-l-m-edit ref="editPage" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import InspectionKLMEdit from "@/views/purchase/Inspection_KLM/Inspection_KLMEdit";

  export default {
    name: "InspectionKLMList",
    components: {InspectionKLMEdit, VmTable, VmSearch},
    data() {
      return {
        delAuth: this.$auth(0),
        idList: "",
        exportLoading: false,
        complaintDate: "",
        filter: {
          factoryNo: "",
          completeEndState: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      reset() {
        this.factoryNo = "";
        this.filter.completeEndState = "";
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      submit(pkid) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.get("basic", "improvedSurveys/submit/" + pkid).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      goto(row) {
        // this.$router.push({
        //   path: "/ImprovedSurvey",
        //   query: {
        //     billType: 28,
        //     billId: row.pkid,
        //     $tabName: row.billNo,
        //   },
        // });
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "shipmentInspectKlms", row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
